export function labels(mode) {
  const owner = mode === "owner";
  return {
    entity: owner ? "business" : "client",
    entityPlural: owner ? "businesses" : "clients",
    Entity: owner ? "Business" : "Client",
    EntityPlural: owner ? "Businesses" : "Clients",
    newEntity: owner ? "New business" : "New client",
    addFirst: owner ? "Add your business" : "Add your first client",
    workspaceTitle: owner ? "My business" : "Your clients",
  };
}

export const PLAN_LABELS = {
  trial: "Free trial",
  expired: "Trial ended",
  starter: "Starter",
  professional: "Professional",
  business: "Business",
  firm: "Business",
};
